import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

interface Banner {
  title: string;
  image: string;
  url: string;
  v: string; // Aux oara agregar como query oaran y evitar cache
}

const BANNERS: Banner[] = [
  {
    title: 'Taller práctico procesal',
    image: 'home-banner-2.png',
    url: 'https://xi9k9veq.sibpages.com',
    v: 'taller_practico_procesal'
  },
  {
    title: 'Presupuestos mínimos ambientales',
    image: 'home-banner-1.png',
    url: '/book/0073000_2ED',
    v: '0073000_2ED'
  },
  {
    title: 'Conocé Astrea Virtual',
    image: 'home-banner-3.png',
    url: '/astreavirtual',
    v: 'astreavirtual'
  },
  {
    title: 'Ver catálogo',
    image: 'home-banner-4.png',
    url: '/store',
    v: 'store'
  },
];

@Component({
  selector: 'astrea-banner-welcome',
  templateUrl: './banner-welcome.component.html',
  styleUrls: ['./banner-welcome.component.scss']
})
export class BannerWelcomeComponent implements OnInit, OnDestroy {
  public banners: Banner[] = BANNERS;
  public currentBannerIndex = 0;
  public intervalId: any;

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    if (this.isBrowser) {
      this.startBannerRotation();
    }
  }

  ngOnDestroy() {
    if (this.isBrowser) {
      this.stopBannerRotation();
    }
  }

  startBannerRotation() {
    this.stopBannerRotation();
    this.intervalId = setInterval(() => {
      this.nextBanner();
    }, 3500);
  }

  stopBannerRotation() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  nextBanner() {
    this.animateChange(() => {
      this.currentBannerIndex = (this.currentBannerIndex + 1) % this.banners.length;
    });
  }

  previousBanner() {
    this.animateChange(() => {
      this.currentBannerIndex = (this.currentBannerIndex - 1 + this.banners.length) % this.banners.length;
    });
  }

  animateChange(action: () => void) {
    action();
    this.cdr.detectChanges();
  }

  get currentBanner(): Banner {
    return this.banners[this.currentBannerIndex];
  }

  get currentImageSrc(): string {
    return `/assets/images/banners/${this.currentBanner.image}?v=${this.currentBanner.v}`;
  }

  get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }
}
